import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip } from "@material-ui/core";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import MaterialTable from "material-table";
import { API_URL } from "../../../config";
import Top from "../Top";
import "../Products/product.css";
import axios from "axios";
import SuccessPop from "../SuccessPop/SuccessPop";
import ErrorPop from "../ErrorrPop/ErrorPop";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import DeleteCoupon from "./DeleteCoupon";
import AddCoupon from "./AddCoupon";
import EditCoupon from "./EditCoupon";
import { Box, MenuItem, Select, Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
  bin1: {
    margin: "5px 0 !important",
    padding: "15px",
    width: "100%",
    border: "1px solid #7c13867d !important",
    borderRadius: "8px ",
    background: "transparent",
    color: "#fff",
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "&:focus-Visible": {
      outline: "none !important",
      border: "none !important",
    },
    "&:hover": {
      border: "none",
    },
    "& .MuiInputBase-root": {
      "&::before": {
        display: "none",
      },
      "&::after": {
        display: "none",
      },
    },

    "&:focus": {
      boxShadow: "none !important",
      border: "1px solid #7c13867d !important",
      borderRadius: "10px !important ",
    },
    "& input": {
      padding: "10px",
      fontSize: "15px",
      borderRadius: "10px",
      fontWeight: "500",
      "&::placeholder": {
        color: "#7C1386 !important",
        fontSize: "15px",
      },
    },
    "& textarea": {
      fontSize: "16px",
      color: "#7c13867d !important",
      padding: "10px !important",
      fontWeight: "500",
    },
  },
  btns: {
    textAlign: "center",
    margin: "10px 0",
    "& button": {
      fontSize: "15px",
      background: "#7C1386 !important",
      borderRadius: "10px",
      textTransform: "capitalize",
      color: "#fff",
      padding: "10px 30px",
      transition: "0.3s all !important",

      "&.Mui-disabled": {
        cursor: "not-allowed !important",
        pointerEvents: "auto !important",
        color: "rgb(255 255 255 / 38%) !important",
        "&:hover": {
          opacity: "1",
          transform: "scale(1) !important",
        },
      },
    },
  },
  error: {
    color: "#f14668",
    fontSize: "14px !important",
    paddingTop: "3px",
    wordBreak: "break-all",
  },
}));

const CouponList = () => {
  const accessToken = localStorage.getItem("accessToken");
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [openAddCoupon, setOpenAddCoupon] = useState(false);
  const handleAdd = () => setOpenAddCoupon(!openAddCoupon);
  const [openEdit, setOpenEdit] = useState(false);
  const handleEditPop = () => setOpenEdit(!openEdit);
  const [openSuccess, setOpenSuccess] = useState(false);
  const handleSuccesssPop = () => setOpenSuccess(!openSuccess);
  const [openDelete, setOpenDelete] = useState(false);
  const handleDeletePop = () => setOpenDelete(!openDelete);
  const handleDeleteOpen = () => setOpenDelete(true);

  const [openError, setOpenError] = useState(false);
  const handleErrorPop = () => setOpenError(!openError);

  const [updateData, setUpdateData] = useState(null);
  const [message, setMessage] = useState("");
  const handleMesssage = (value) => setMessage(value);
  const [deleteId, setDeleteId] = useState("");
  const [filterSelect, setFilterSelect] = useState("0");

   const logout = () => {
    localStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    if (filterSelect) {
      getAllCoupons(filterSelect);
    } else {
      getAllCoupons(0);
    }
  }, [filterSelect]);

  const getAllCoupons = (filterSelect) => {
    let url = `${API_URL}/get/all-discount`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        let _temp = [];
        resp.discounts.map((v, i) => {
          console.log(v);
          
          filterSelect === v.type
            ? _temp.push({
                code: v.code,
                type: v.type.charAt(0).toUpperCase() + v.type.slice(1),
                value: v.type === "percentage" ? `${v.value}%` : `$${v.value}`,
                affiliateId: v.affilliateId?v.affilliateId:"N/A",
                createdBy: v.createdBy,
                status: (
                  <span
                    style={{
                      color: v.status == 1 ? "green" : "red",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    }}
                  >
                    {v.status == 1 ? "Active" : "Inactive"}
                  </span>
                ),

                action: (
                  <p className="action-p">
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Edit"
                      placement="top"
                    >
                      <i
                        className="fa fa-edit action-icon"
                        onClick={() => handleEdit(v.id)}
                      ></i>
                    </Tooltip>
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Delete"
                      plac
                      ement="top"
                    >
                      <i
                        className="fa fa-trash-o action-icon"
                        onClick={() => handleDelete(v.id)}
                      ></i>
                    </Tooltip>
                  </p>
                ),
              })
            : filterSelect == 0 &&
              _temp.push({
                code: v.code,
                type: v.type.charAt(0).toUpperCase() + v.type.slice(1),
                value: v.type === "percentage" ? `${v.value}%` : `$${v.value}`,
                createdBy: v.createdBy,
                affiliateId: v.affilliateId?v.firstName + " " + v.lastName : "No",
                status: (
                  <span
                    style={{
                      color: v.status == 1 ? "green" : "red",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    }}
                  >
                    {v.status == 1 ? "Active" : "Inactive"}
                  </span>
                ),
                action: (
                  <p className="action-p">
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Edit"
                      placement="top"
                    >
                      <i
                        className="fa fa-edit action-icon"
                        onClick={() => handleEdit(v.id)}
                      ></i>
                    </Tooltip>
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                      }}
                      title="Delete"
                      plac
                      ement="top"
                    >
                      <i
                        className="fa fa-trash-o action-icon"
                        onClick={() => handleDelete(v.id)}
                      ></i>
                    </Tooltip>
                  </p>
                ),
              });
        });
        let revData = _temp.reverse();
        setData(revData);
      } else if (response.status == 401) {
        logout();
      } else {
        alert("network error");
      }
    });
  };

  const handleEdit = (id) => {
    setOpenEdit(true);
    getCouponByID(id);
  };

  const getCouponByID = (id) => {
    const accessToken = localStorage.getItem("accessToken");
    fetch(API_URL + `/get/discount/by/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    }).then(async (response) => {
      if (response.status == 200) {
        const resp = await response.json();
        setUpdateData(resp.discount);
      } else if (response.status == 401) {
        logout();
      } else {
        console.log("network error");
      }
    });
  };

  const handleDelete = (id) => {
    handleDeleteOpen();
    setDeleteId(id);
  };

  const deleteCoupon = () => {
    fetch(API_URL + `/delete/discount/by/${deleteId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": accessToken,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        getAllCoupons(0);
        handleDeletePop();
        handleMesssage(data.message);
        handleSuccesssPop();
      })
      .catch((error) => {
        console.error("Error during DELETE request:", error);
      });
  };

  const handleAddFaq = () => {
    handleAdd();
  };

  const columns = [
    {
      title: "Coupon Code",
      field: "code",
    },
    {
      title: "Discount Type",
      field: "type",
    },
    {
      title: "Discount",
      field: "value",
    },
    {
      title: "For Affiliate ?",
      field: "affiliateId",
    },
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Action",
      field: "action",
    },
  ];

  const handleFilterSelect = (e) => {
    setFilterSelect(e.target.value);
  };

  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="onlineaccess-wrp">
            <div className="onlineaccess-child1">
              <h3>Discount Coupons</h3>
            </div>
            <div className="add-btn">
              <button onClick={handleAddFaq}>Add Coupon</button>
            </div>
          </div>

          <Box
            sx={{
              width: "20%",
              display: "flex",
              flexDirection: "column",
              padding: "0.5rem 0rem 1rem 0rem",
              gap: 1,
              "@media(max-width:600px)": { width: "100% !important" },
            }}
          >
            <Typography
              component={"label"}
              sx={{ fontWeight: "600", color: "#7C1386" }}
            >
              Filter by type
            </Typography>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              placeholder="Select Categroy"
              value={filterSelect}
              label="Categroy"
              onChange={(e) => handleFilterSelect(e)}
              variant="standard"
              sx={{
                "& .MuiSelect-select": {
                  padding: "10px !important",
                  border: "1px solid purple !important",
                  borderRadius: "5px",
                },
                "&::before": {
                  borderBottom: "none !important",
                },
                "&:hover:not(.Mui-disabled):before": {
                  borderBottom: "none !important",
                },
                "&::after": {
                  borderBottom: "none !important",
                },
              }}
            >
              <MenuItem value="0">All</MenuItem>
              <MenuItem value="percentage">Percentage</MenuItem>
              <MenuItem value="amount">Amount</MenuItem>
            </Select>
          </Box>

          <div className="wrp-bankform">
            <div className="mobiletable">
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  options={{
                    search: true,
                    showTitle: false,
                    toolbar: true,
                    pageSize: 20,
                    //  pageSize: data?.length <= 5 ? 5 : data?.length > 5 && data?.length <= 10 ? 10 : data?.length > 10 && data?.length <= 20 ? 20 : data?.length > 20 && data?.length <= 30 ? 30 : data?.length > 30 && data?.length <= 40 ? 40 : data?.length > 40 && data?.length <= 50 ? 50 : data?.length > 50 && data?.length <= 100 ? 100 : 150,
                    pageSizeOptions: [5, 10, 20, 50, 100, 150, 200],
                  }}
                  columns={columns}
                  data={data}
                  title=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <SuccessPop
        handleSuccesssPop={handleSuccesssPop}
        openSuccess={openSuccess}
        message={message}
      />
      <ErrorPop
        handleErrorPop={handleErrorPop}
        openError={openError}
        message={message}
      />

      <AddCoupon
        openAddCoupon={openAddCoupon}
        classes={classes}
        getAllCoupons={getAllCoupons}
        handleAdd={handleAdd}
        handleErrorPop={handleErrorPop}
        handleSuccessPop={handleSuccesssPop}
        handleMessage={handleMesssage}
      />
      <EditCoupon
        updateData={updateData}
        openAddCoupon={openEdit}
        classes={classes}
        getAllCoupons={getAllCoupons}
        handleAdd={handleEditPop}
        handleErrorPop={handleErrorPop}
        handleSuccessPop={handleSuccesssPop}
        handleMessage={handleMesssage}
      />
      <DeleteCoupon
        handleSuccesssPop={handleDeletePop}
        openSuccess={openDelete}
        deleteCoupon={deleteCoupon}
      />
    </div>
  );
};

export default CouponList;
